function toCamelCase(text) {
  if (!text) return text;
  
  // Special cases for all-uppercase acronyms
  const upperText = text.toUpperCase();
  if (upperText === 'POV') return 'POV';
  
  return (
    text.charAt(0).toUpperCase() + text.slice(1).replace(/([A-Z])/g, ' $1')
  );
}

export default toCamelCase;
